const config = ["linkCheck", "securityPlugin","storyResource","storyImport","storyLayout"];
export default config;